import React from "react";
import { Box } from "app/components/common";
import RecordMediaBlock from "../../Record/Record.web";

export interface IAudioAnalysisProps {
  setAudioIsPlaying: (boolean) => void;
}

const AudioAnalysis = ({ setAudioIsPlaying }: IAudioAnalysisProps) => {
  return (
    <Box width="100%" flex={1} alignItems="center" justifyContent="center">
      <RecordMediaBlock onSubmit={() => null} recordType="audio" />
    </Box>
  );
};

export default AudioAnalysis;
